module.exports = __webpack_public_path__ + "static/media/seahorse.36faee7f.png";